export const IS_SPLASH_VISITED = 'IS_SPLASH_VISITED';

export enum LAYER_POSITION {
    TOP = 'top',
    BOTTOM = 'bottom'
}
